import React, { useEffect, useState } from "react";
import TopNavigator from "../components/TopNavigator";
import TredeDetail from "../components/TredeDetail";
import UserBalanceDetial from "../components/UserBalanceDetial";
import { fetchUserPortalDetails } from "../utils/userPortalApi";

function TransactionsPage() {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("transactions");

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchUserPortalDetails();
        setDetails(data);
      } catch (err) {
        setError(err.message || "خطا در دریافت گردش حساب");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const transactions = details?.transactions || [];
  const statement = details?.statement || [];

  const formatAmount = (value) =>
    Number(value || 0).toLocaleString("fa-IR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  const formatDate = (value) => {
    if (!value) return "-";
    return new Date(value).toLocaleString("fa-IR");
  };

  const renderEmpty = (message) => <p className="UserPortalEmpty">{message}</p>;

  return (
    <div className="MainPageShell">
      <TopNavigator />
      <main className="container UserPortalPage">
        <UserBalanceDetial />
        <TredeDetail />
      </main>
    </div>
  );
}

export default TransactionsPage;
